import { TrackingUser } from '@tabeeb/contracts/main-api/swagger-main-api'
import { CheckInRow } from './CheckInsTable.types'

export const hasExpandableChildren = (user: TrackingUser): boolean => {
  const qualifications = user.Qualifications || []
  return qualifications.length > 1 || (qualifications.length === 1 && (qualifications[0].Certificates?.length || 0) > 1)
}

export const getCertificate = (row: CheckInRow) =>
  row.certificate || row.qualification?.Certificates?.[0] || row.Qualifications?.[0]?.Certificates?.[0]

export const getQualification = (row: CheckInRow) => row.qualification || row.Qualifications?.[0]

export const getRootRowId = (userId: number | undefined) => `user-${userId}`

export const getRowId = (row: CheckInRow): string => {
  if (row.isRoot) {
    return getRootRowId(row.Id)
  }
  if (row.certificateIndex !== undefined) {
    return `user-${row.Id}-qual-${row.qualificationIndex}-cert-${row.certificateIndex}`
  }
  return `user-${row.Id}-qual-${row.qualificationIndex}`
}

export const getTreeDataPath = (row: CheckInRow): string[] => {
  const path = [getRootRowId(row.Id)]

  if (!row.isRoot) {
    if (row.certificateIndex !== undefined) {
      path.push(`cert-${row.qualificationIndex}-${row.certificateIndex}`)
    } else {
      path.push(`qual-${row.qualificationIndex}`)
    }
  }

  return path
}
